<template>
  <div class="footer-wrap">
    <div class="footer-content-wrap">
      <div id="bomFooter">
        <div class="bash-box">
          <div class="wechat-box">
            <p class="wechat-title"><i class="wechat-icon" style="background: url(img/wechat_icon.png) no-repeat 50% 50%;"></i>微信公众号</p>
            <i class="wechat-qrcode"   :style="'background: url('+settings.gzh+') no-repeat 50% 40%;'"></i>
            <p class="wechat-detail">关注{{settings.gongsiName}}公众号</p>
          </div>
          <ul class="footer-content-ul" style="    margin: 0 auto;">
            <li v-for="(item, index) in footer" :key="index">
              <p class="h4">{{ item.name }}</p>
              <a
                class="go-next"
                target="_blank"
                :href="addOrgToUrl(item2.url,'qiyeId',GetUrlParam('qiyeId'))"
                v-for="(item2, index2) in item.children"
                :key="index2"
                >{{ item2.name }}</a
              >
            </li>
          </ul>
        </div>
      </div>

      <div class="bash-box l60"></div>
    </div>
    <div class="footer-copyright-wrap">
      <div class="bash-box" style="justify-content: center;">
        <span>Copyright@ 2010 <span id="lblyear"></span></span>
        <span class="padding-10"> {{settings.gongsiName}} </span>
        <a
          class="go-next"
          href="http://beian.miit.gov.cn"
          target="_blank"
      
          ><span style="padding-left: 10px" class="flex-span">
           {{settings.beian}}
          </span></a
        >
        <span class="padding-20"
          >公司地址：  {{settings.address}}</span
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  props: {
    footer: Object,
    settings: Object,
  },
  methods:{
         addOrgToUrl(url,paramName,replaceWith){
    //url字符串添加参数
    //url:路径地址 paramName：参数名 replaceWith：参数值
      if (url.indexOf(paramName) > -1) {
          var re = eval('/(' + paramName + '=)([^&]*)/gi');
          url = url.replace(re, paramName + '=' + replaceWith);
      } else {
          var paraStr = paramName + '=' + replaceWith;

          var idx = url.indexOf('?');
          if (idx < 0)
              url += '?';
          else if (idx >= 0 && idx != url.length - 1)
              url += '&';
          url=url + paraStr;
      }
      return url;
    },
    GetUrlParam(paraName) {
    　　　　var url = window.location.toString();
    　　　　var arrObj = url.split("?");
 
    　　　　if (arrObj.length > 1) {
    　　　　　　var arrPara = arrObj[1].split("&");
    　　　　　　var arr;
 
    　　　　　　for (var i = 0; i < arrPara.length; i++) {
    　　　　　　　　arr = arrPara[i].split("=");
 
    　　　　　　　　if (arr != null && arr[0] == paraName) {
    　　　　　　　　　　return arr[1];
    　　　　　　　　}
    　　　　　　}
    　　　　　　return "";
    　　　　}
    　　　　else {
    　　　　　　return "";
    　　　　}
    　　}
  }
};
</script>
<style scoped>
i{
  display: block;
  width: 144px;
  height: 144px;
  background-size:100% !important;
}
</style>
